import React from "react";
import { useTranslation } from "react-i18next";
var NotFound = function () {
    var t = useTranslation().t;
    return (React.createElement("div", { className: "full-height-container" },
        React.createElement("h1", { className: "text-neutrals-1700 font-medium" }, t("invalid-data")),
        React.createElement("img", { src: "https://dev-files.maatai.com/maatilda/maatilda_ops.svg", alt: "image-matilda-ops" })));
};
NotFound.propTypes = {};
export default NotFound;
